module.exports = {"341271100":"袁集镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341271.json
// module id = 1234
// module chunks = 0